// Schema version 1: stamp cc_throttle_ms default into settings.
// Ensures configs downloaded before MDL-222 have an explicit throttle value
// so the performance test framework can rely on the field existing.
export default {
  schema_version: 1,
  migrate(config) {
    if (!config.settings) config.settings = {};
    if (config.settings.cc_throttle_ms === undefined) {
      config.settings.cc_throttle_ms = 100;
    }
  },
};
